const MenuIcon = () => {
    return (
        <svg
            xmlns={'http://www.w3.org/2000/svg'}
            width={'28'}
            height={'28'}
            viewBox={'0 0 28 28'}
            fill={'none'}
        >
            <path
                d={'M4.375 7.875H23.625M4.375 14H23.625M4.375 20.125H23.625'}
                stroke={'currentColor'}
                strokeWidth={'1.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    );
};

export default MenuIcon;
